"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var Warnings = {
  entityUnavailable: {
    use: 'danger',
    message: 'missingEntityPermissions',
    disconnect: false,
    reconnect: false
  },
  entityMissingPermissions: {
    use: 'danger',
    message: 'missingEntityPermissions',
    disconnect: true,
    reconnect: true
  },
  ACCOUNT_NOT_CONNECTED: {
    use: 'danger',
    message: 'accountNotConnected',
    disconnect: true,
    reconnect: true
  },
  INVALID_AUTH: {
    use: 'danger',
    message: 'missingPermissions',
    disconnect: true,
    reconnect: true
  },
  LEAD_LEVEL_FAILURES: {
    use: 'danger',
    message: 'leadLevelFailures',
    disconnect: false,
    reconnect: false
  },
  THROTTLED_BY_NETWORK: {
    use: 'danger',
    message: 'throttled',
    disconnect: false,
    reconnect: false
  },
  USER_CANNOT_ACCESS_PAGE: {
    use: 'danger',
    message: 'missingEntityPermissions',
    disconnect: false,
    reconnect: false
  },
  USER_MISSING_PERMISSIONS: {
    use: 'danger',
    message: 'missingEntityPermissions',
    disconnect: false,
    reconnect: false
  },
  NO_VALUES_FOUND: {
    use: 'danger',
    message: 'noValues',
    disconnect: false,
    reconnect: false
  },
  ENTITY_NOT_FOUND_IN_NETWORK: {
    use: 'danger',
    message: 'pageNotFound',
    disconnect: true,
    reconnect: false
  },
  FACEBOOK_PAGE_MIGRATED: {
    use: 'danger',
    message: 'pageMoved',
    disconnect: true,
    reconnect: false
  },
  UNKNOWN: {
    use: 'danger',
    message: 'unknown',
    disconnect: false,
    reconnect: false
  }
};

var _default = (0, _immutable.Record)({
  id: null,
  name: null,
  adNetwork: null,
  networkUserId: null,
  subscribed: null,
  available: null,
  hasAcceptedTos: null,
  error: null,
  lastSyncedAt: null,
  lastSubmissionWithoutEmail: null,
  getWarningLevel: function getWarningLevel() {
    if (this.error) {
      return Warnings[this.error];
    }

    if (!this.available) {
      return Warnings.entityUnavailable;
    }

    return null;
  }
}, 'LeadSyncingEntity');

exports.default = _default;
module.exports = exports.default;